import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
    },
});

class CheckboxDetails extends React.Component {
    handleInitialValueChange = (event) => {
        const eventObj = {
            target: {
                id: event.target.name,
                value: false,
            },
        };
        if (event.target.value === 'true') {
            eventObj.target.value = true;
        }
        this.props.handleChange(eventObj);
    };

    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="instructions"
                            label="Field Instructions"
                            value={this.props.field.instructions}
                            margin="normal"
                            variant="outlined"
                            multiline
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="label"
                            label="Field Label"
                            value={this.props.field.label}
                            variant="outlined"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2">Display Default Answer:</Typography>
                        <FormControlLabel
                            checked={this.props.field.initialValue === true}
                            name="initialValue"
                            value={true}
                            control={<Radio classes={this.props.classes.grey} />}
                            label="Checked"
                            labelPlacement="end"
                            onChange={this.handleInitialValueChange}
                        />
                        <FormControlLabel
                            checked={this.props.field.initialValue === null || this.props.field.initialValue === false}
                            name="initialValue"
                            value={false}
                            control={<Radio classes={this.props.classes.grey} />}
                            label="Unchecked"
                            labelPlacement="end"
                            onChange={this.handleInitialValueChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            id="additionalInfo"
                            label="Additional Info"
                            multiline
                            rows={4}
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            value={this.props.field.additionalInfo}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(CheckboxDetails);
